export default __webpack_public_path__ + "static/media/hair-transplantation.83048396.JPG";